import { apiUrl } from "../utils/api"

export const SMARTSENSE_SENSOR_TYPE = "smartsense"

/** Aceita tipo legado durante transição de dados em cache. */
export function isSmartSenseSensor(sensor) {
  if (!sensor) return false
  const t = String(sensor.type || sensor.sensor_type || "").toLowerCase()
  return (
    t === SMARTSENSE_SENSOR_TYPE ||
    t === "temp_humidity_sensor" ||
    t.includes("temp_humidity")
  )
}

/** Nome legível do sensor SmartSense (cadastro, alocação ou relatório). */
export function smartsenseSensorDisplayName(sensor) {
  if (!sensor || typeof sensor !== "object") return null
  const alloc =
    sensor.allocation && typeof sensor.allocation === "object" ? sensor.allocation : null
  const data = sensor.data && typeof sensor.data === "object" ? sensor.data : null
  const candidates = [
    sensor.name,
    sensor.sensor_name,
    sensor.smartsense_sensor_name,
    sensor.temp_humidity_sensor_name,
    sensor.display_name,
    sensor.label,
    sensor.title,
    sensor.nickname,
    sensor.device_name,
    sensor.barn_sensor_name,
    alloc && alloc.name,
    alloc && alloc.sensor_name,
    alloc && alloc.label,
    alloc && alloc.title,
    data && data.name,
    data && data.sensor_name,
    data && data.label,
  ]
  for (const c of candidates) {
    if (c == null) continue
    const t = String(c).trim()
    if (t) return t
  }
  return null
}

export const smartsenseApi = {
  acquisitions: apiUrl('smartsense_acquisition/'),
  acquisition: (id) => apiUrl(`smartsense_acquisition/${id}/`),
  allocations: apiUrl('smartsense_sensor_allocation/'),
  allocation: (id) => apiUrl(`smartsense_sensor_allocation/${id}/`),
  batchReport: (batchPk) => apiUrl(`smartsense_acquisition/batch_report/${batchPk}/`),
  lastData: (sensorPk) => apiUrl(`smartsense_acquisition/get_last_smartsense_data/${sensorPk}/`),
  barnSensorsHome: (barnPk) => apiUrl(`sensors/report/home/barn=${barnPk}`),
}
